import { useNavigate } from 'react-router-dom';
import { usePets } from '../../contexts/PetsContext';
import Button from '../../components/ui/Button';
import Card from '../../components/ui/Card';
import { CalendarDays, PawPrint } from 'lucide-react';
import { ROUTES } from '../../config/constants';
import AppointmentForm from './components/AppointmentForm';

/**
 * Página de creación de cita. Wrapper de AppointmentForm.
 *
 * Si no hay mascotas en el hogar, muestra empty state que invita a crear
 * la primera mascota antes (no se puede agendar sin pets).
 */
const AppointmentNewPage = () => {
  const { pets, status: petsStatus } = usePets();
  const navigate = useNavigate();

  const noPets = petsStatus === 'ready' && pets.length === 0;

  if (noPets) {
    return (
      <div className="flex flex-col gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Nueva cita</h1>
        </div>
        <Card>
          <div className="flex flex-col items-center gap-3 py-6 text-center">
            <PawPrint className="h-10 w-10 text-slate-300" aria-hidden="true" />
            <div>
              <p className="font-medium text-slate-800">No hay mascotas todavía</p>
              <p className="mt-1 text-sm text-slate-500">
                Necesitás al menos una mascota para agendar una cita.
              </p>
            </div>
            <div className="flex gap-2 w-full">
              <Button
                variant="secondary"
                fullWidth
                onClick={() => navigate(ROUTES.CALENDAR)}
              >
                Volver
              </Button>
              <Button
                variant="primary"
                fullWidth
                onClick={() => navigate(ROUTES.PET_NEW)}
              >
                Crear mascota
              </Button>
            </div>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-start gap-2">
        <CalendarDays className="h-6 w-6 text-brand-700" aria-hidden="true" />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Nueva cita</h1>
          <p className="text-sm text-slate-500">
            Agendá una visita, vacuna o evento del hogar.
          </p>
        </div>
      </div>
      <AppointmentForm />
    </div>
  );
};

export default AppointmentNewPage;
